export const phoneRule = (value: string, [validatorFn]: [() => boolean]) => {
  if (value.trim() === '') return true

  if (!validatorFn) return 'Internal error: no phone validator provided'
  return validatorFn()
}
